<template>
    <li class="kudos__item" :class="'kudos-image-' + item.class">
        <div class="kudos__item__border"
             :class="(wallpaper.kudos != null && (item.fileName == wallpaper.kudos.fileName)) ? 'is-active' : ''"
             @click="selectKudos">
            <img :src="imageSrc">
        </div>
    </li>
</template>

<script>
    export default {
        props: ['item', 'wallpaper'],
        computed: {
            imageSrc() {
                return require('../../assets/kudos/' + this.item.fileName);
            }
        },
        methods: {
            selectKudos() {
                this.$emit('kudosSelected', this.item);
            }
        }

    }
</script>

<style lang="scss" scoped>
    .kudos__item {
        cursor: pointer;
        display: inline-block;

        &__border {
            border: 1px solid rgba(255, 255, 255, 0.3);
            height: 127px;
            padding: 16px;
            transition: border .2s linear;

            &:hover {
                border: 1px solid rgba(255, 255, 255, 1);
            }

            &.is-active {
                border: 1px solid rgba(255, 255, 255, 1);
                position: relative;

                &::before {
                    background: transparent url('../../assets/checked.svg');
                    content: '';
                    height: 7px;
                    position: absolute;
                    top: 8px;
                    right: 9px;
                    width: 9px;

                }
            }
        }

        img {
            display: inline-block;
            margin: auto;
            height: 100%;
            width: 100%;
        }
    }

    .kudos-image-two-lines {
        text-align: center;
        img {
            width: 80%;
        }
    }

    .kudos-image-three-lines {
        text-align: center;
        img {
            width: 75%;
        }
    }

    .kudos-image-four-lines {
        text-align: center;
        img {
            width: 70%;
        }
    }

    .kudos__item--78, .kudos__item--82, .kudos__item--84,
    .kudos__item--85, .kudos__item--86 {
        @extend .kudos-image-two-lines;
    }


</style>


// WEBPACK FOOTER //
// src/components/panels/KudosItem.vue